module.exports = __webpack_public_path__ + "68d38e67bf4d1b515dc222c1f5b48856.webp";